var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPenBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.221 0.780313C10.7182 0.276903 10.0492 0 9.33659 0C8.62517 0 7.95621 0.276903 7.45218 0.780313L0.969998 7.26253C0.718909 7.51301 0.55522 7.83113 0.496755 8.1813L0.0105904 11.0972C-0.0306424 11.3439 0.0499707 11.5963 0.22721 11.7729C0.373679 11.9194 0.571823 12 0.776141 12C0.817989 12 0.861102 11.9969 0.90295 11.9896L3.81938 11.5034C4.16893 11.4455 4.48649 11.2818 4.73758 11.0307L11.2198 4.54853C11.7232 4.04512 12.0007 3.37616 12.0007 2.66412C12.0007 1.95209 11.725 1.28372 11.221 0.780313ZM4.08648 10.3784C3.97201 10.4928 3.82802 10.5667 3.66924 10.5932L0.956476 11.0449L1.4082 8.33275C1.43466 8.17336 1.50912 8.02936 1.62298 7.91551L6.59738 2.9411L9.06025 5.40397L4.08648 10.3784ZM10.5687 3.89623L9.71323 4.75159L7.25032 2.28873L8.10576 1.43329C8.43501 1.10466 8.87194 0.923123 9.33719 0.923123C9.80245 0.923123 10.24 1.10404 10.5687 1.43329C10.8973 1.76254 11.0788 2.19947 11.0788 2.66472C11.0788 3.12998 10.8973 3.56698 10.5687 3.89623Z",
    fill: "#0088FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPenBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editPenBlue.a10ebe80fca68d0331601bd157863ae5.svg";